// src/modules/shared/dashboard/PeriodContext.tsx
import { createContext, useContext, ReactNode } from "react";
import { Period } from "./usePeriodFilter";

const PeriodContext = createContext<Period>("30d");

export function PeriodProvider({ value, children }: { value: Period; children: ReactNode }) {
  return <PeriodContext.Provider value={value}>{children}</PeriodContext.Provider>;
}

export function usePeriod(): Period {
  return useContext(PeriodContext);
}
